import $ from 'jquery'
import common from './common'
// 设置 rem 函数
function setRem () {   
    var whdef = 48 / 1920;
    var wH = window.innerHeight;
    var wW = window.innerWidth;
    var isPhone = common.isPhone();
    var isiOS = common.isiOS();
    var rem;
    if(isPhone || isiOS){
        // 320 默认大小16px; 320px = 20rem ;每个元素px基础上/16
        let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
        //得到html的Dom元素
        let htmlDom = document.getElementsByTagName('html')[0];
        //设置根元素字体大小
        
        if(htmlWidth >= 768){

            $('html').css('margin', '0 auto');
            htmlDom.style.fontSize= htmlWidth/50+ 'px';
        }else{

            htmlDom.style.fontSize= htmlWidth/10 + 'px';
        }
    } else {
        rem = wW * whdef;
        $('html').css('min-width', '1024px');
        $('body').css('min-width', '1024px');
        $('html').css('font-size', rem + 'px');
        $('body').css('font-size', rem + 'px');
    }
    
}
// 初始化
setRem();
// 改变窗口大小时重新设置 rem
window.onresize = function () {
    setRem()
}